module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-48x48-480ab283a45087c3f9efa55db430e94a.png";